const isGecrosModule = (modules, currentModule) => {
    let gecrosModule = modules.filter((m) => m.title === currentModule);
    return gecrosModule.length > 0;
};

export default isGecrosModule;